<script setup lang="ts">
import { ref, watch } from 'vue'

import ParamsTab from '@/components/ide/ide/tabs/ApiTabComp/ParamsTab/ParamsTab.vue'
import AuthorizationTab from '@/components/ide/ide/tabs/ApiTabComp/AuthorizationTab/AuthorizationTab.vue'
import HeadersTab from '@/components/ide/ide/tabs/ApiTabComp/HeadersTab/HeadersTab.vue'
import BodyTab from '@/components/ide/ide/tabs/ApiTabComp/BodyTab/BodyTab.vue'
import { RequestSection } from '@/utils/apiTab'

const props = defineProps({
  selectedRequestFieldValue: {
    type: String,
    required: true
  },
  activeRequestIndex: {
    type: Number,
    required: true
  }
})

const selectedRequestValue = ref<RequestSection>(RequestSection.PARAMS)

watch(
  () => props.selectedRequestFieldValue,
  (value) => {
    if (Object.values(RequestSection).includes(value as RequestSection)) {
      selectedRequestValue.value = value as RequestSection
    }
  }
)
</script>

<template>
  <div class="h-full w-full">
    <div v-if="selectedRequestValue == RequestSection.PARAMS">
      <ParamsTab :activeRequestIndex="activeRequestIndex" />
    </div>
    <div v-if="selectedRequestValue == RequestSection.AUTHORIZATION">
      <AuthorizationTab :activeRequestIndex="activeRequestIndex" />
    </div>
    <div v-if="selectedRequestValue == RequestSection.HEADERS">
      <HeadersTab :activeRequestIndex="activeRequestIndex" />
    </div>
    <div v-if="selectedRequestValue == RequestSection.BODY">
      <BodyTab :activeRequestIndex="activeRequestIndex" />
    </div>
  </div>
</template>
